<div>
  <mat-card appearance="outlined">
    <mat-card-content fxLayout="row" fxLayoutAlign="end" fxLayoutGap="8px">
      <div *appSpinner="loading; diameter: 40; color: 'primary'"></div>
      <div fxFlex=""></div>
    </mat-card-content>
  </mat-card>
</div>
